module.exports = __webpack_public_path__ + "static/media/q-led-mini_pl.032b0b8f.pdf";